
import React from 'react';
import BaseComponent from './Base';
import { Line } from 'react-chartjs-2';
import { Link } from 'react-router-dom';

class Dashboard extends BaseComponent {
    constructor(props) {
      let config = {
        subModuleName : 'dashboard',
        filterParams: []
      };

      super(props,config);
      this.lockScreen();
      this.state.showConfig={
        email:true,
        mobile:true,
        direct:true,
        ip:true
      }
      this.state.lastRequests = null;
      this.interval = setInterval(() => this.getLastRequests(), 60000);
      this.getLastRequests()
    }
    getLastRequests(){
      this.httpPost("/api/organ/ajax/lastRequests/")
      .then(dataHolder => {
        this.setState({ lastRequests:dataHolder });
      });
    }
    getDocForRequest(_req){
      let res = null;
      if (_req.RequestType === 7)
      {
        this.state.lastRequests.isi.forEach(_r=>{
          if (_r.Paper_ID === _req.RqstdFileID)
            res = _r.Title;
        })
      }
      else{
        this.state.lastRequests.documents.forEach(_r=>{
          if (_r.id === _req.RqstdFileID)
            res = _r.title;
        })
      }
      return res;
    }
    renderLiveBoxs(){
      return (
        <div className="box box-success">
          <div className="box-header with-border">
            <h3 className="box-title"><i className="fas fa-sync fa-spin"></i> گزارش لحظه ای دریافتهای اخیر</h3>
          </div>
          <div className="box-body no-padding">
            <div id="liveRequests">
              {this.state.lastRequests === null ?
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <p><i className="fas fa-sync fa-spin"></i></p>
                </div>
              :
                this.state.lastRequests.requests.map((_req,_index)=>
                  <div className="col-md-12 col-sm-12 col-xs-12">
                    گیرنده: {_req.RealPerson !== null ? _req.RealPerson.fname + ' ' + _req.RealPerson.lname : _req.UserEMail}
                    <label className="label label-info pull-left mr-r-5">{this.g2j(_req.AddDate,6)}</label>
                    <label className="label label-danger pull-left mr-r-5">نحوه دریافت: {this.enumString(_req.mode,'mode')}</label>
                    <br/>
                    <p className="clearfix" style={{"display":"inline-block"}}>مقاله: {this.getDocForRequest(_req)}</p>
                    {_index < this.state.lastRequests.requests.length-1 ?
                    <hr/>
                    :null}
                  </div>
                )
              }
            </div>
          </div>
        </div>
      )
    }
    renderTicketsBoxs(){
      return (
        <div className="box box-success">
          <div className="box-header with-border">
            <h3 className="box-title">آخرین پیامهای پیشتیبانی</h3>
          </div>
          <div className="box-body no-padding">
            <div>
              {this.state.data.tickets.map( (_t,_tIndex)=>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="box-body">
                    <ul className="products-list product-list-in-box">
                      <div className="item">
                        {!this.isNull(_t.Person) && _t.Person.fname + ' ' + _t.Person.lname}
                        <p className="message">
                          <Link to={"/tickets/view/" + _t.id} className="name">
                            <p className="message" dangerouslySetInnerHTML={{__html: _t.Details[0].content}}></p>                              
                          </Link>
                        </p>
                        <p className="box-title">
                          <span className={_t.ticket_status === 1 ? "label text-yellow" : _t.ticket_status === 2 ? "label text-green" : _t.ticket_status === 2 ? "label text-blue" : "label text-red"}>{this.enumString(_t.ticket_status,"ticket_status")}</span>
                          <span className="label label-info pull-left"><i className="fal fa-clock"></i> {this.g2j(_t.edit_date,6)}</span>
                        </p>
                      </div>
                    </ul>
                  </div>
                  {_tIndex < this.state.data.tickets.length-1 && <hr style={{"margin":"5px 0"}}/>}
                </div>
              )}
              {this.isEmpty(this.state.data.tickets) &&
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <p>کاربر گرامی در حال حاضر پیامی در صندوق دریافتی و ارسالی شما وجود ندارد</p>
                </div>
              }
            </div>
          </div>
        </div>
      )
    }
    getSaleChartData(){
      let labels = [];
      let ip = [];
      let direct = [];
      let mobile = [];
      let email = [];

      this.state.data.requestsStatistics.forEach(e=>{

        var dateChanged = true;

        if (labels.length>0)
        {
          if (labels[labels.length-1] != this.g2j(e.date)) dateChanged = true
          else dateChanged = false;
        }

        //تاریخ عوض شده
        if (dateChanged)
        {
          ip.push(0);
          direct.push(0);
          mobile.push(0);
          email.push(0);
          labels.push(this.g2j(e.date));
        }

        if (e.mode === 2) mobile[mobile.length-1] += e.count;
        if (e.mode === 3) ip[ip.length-1] += e.count;
        if (e.mode === 5) direct[direct.length-1] += e.count;
        if (e.mode === 7) email[email.length-1] += e.count;
      });

      var datasets = [];
      if (this.state.showConfig.ip)
        datasets.push({
          label:'دریافتهای آی پی',
          fill: false,
          backgroundColor: '#39cccc',
          borderColor: '#39cccc',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: ip
        });
      if (this.state.showConfig.ip)
        datasets.push();
      if (this.state.showConfig.direct)
        datasets.push({
          label:'دریافتهای مستقیم',
          fill: false,
          backgroundColor: '#f39c12',
          borderColor: '#f39c12',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: direct
        });
      if (this.state.showConfig.mobile)
        datasets.push({
          label:'دریافتهای موبایلی',
          fill: false,
          backgroundColor: '#00a65a',
          borderColor: '#00a65a',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: mobile
        });
      if (this.state.showConfig.email)
        datasets.push({
          label:'دریافتهای ایمیلی',
          fill: false,
          backgroundColor: '#605ca8',
          borderColor: '#605ca8',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255,99,132,0.4)',
          hoverBorderColor: 'rgba(255,99,132,1)',
          data: email
        });

      var bardata = {
        labels: labels,
        datasets: datasets
      };
      return bardata;
    }
    renderStatisticBoxs(){
      return (
        <div className="box box-warning">
          <div className="box-header with-border">
            <h3 className="box-title">گزارش دریافتی های مرکز طی ۳۰ روز اخیر</h3>
          </div>
          <div className="box-body no-padding">
            <div>
              <Line data={this.getSaleChartData()} options={{
                legend: { display: true, },
                scales: {
                  yAxes: [{
                    ticks: {
                        fontFamily:'IRANSans',
                        beginAtZero: true
                    }
                  }],
                  xAxes: [{
                    ticks: {
                        fontFamily:'IRANSans'
                    }
                  }]
                }
              }} />                
            </div>
            <div className="text-center mr-5">
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.ip = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای آی پی&nbsp;
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.direct = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای مستقیم&nbsp;
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.mobile = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای موبایلی&nbsp;
              <input defaultChecked={this.state.showConfig.ip} onChange={e=>{
                this.state.showConfig.email = e.target.checked;
                this.setState({showConfig:this.state.showConfig})
              }} type="checkbox" /> درخواستهای ایمیلی
            </div>
          </div>
        </div>
      )
    }
    render() {
      if (this.state.data === null || this.state.data === undefined)
        return this.showLoading();
      if (this.state.data.status === 500 || this.state.data.status === 0)
        return this.render500()
      if (this.state.data.status === 404)
        return this.render404()
      if (this.state.data.status === 2)
        return this.renderNoAccess()
      return(
        <div className="row">
          <div className="col-md-7">
            
            {(this.state.data.current_user.LegalPerson.role_id === 1 || this.state.data.current_user.LegalPerson.role_id === 2||
              this.state.data.current_user.LegalPerson.role_id === 3 || this.state.data.current_user.LegalPerson.role_id === 4  ||
              this.state.data.current_user.LegalPerson.role_id === 5) &&
            [
              this.renderLiveBoxs()
            ,
              this.renderStatisticBoxs()
            ]}
          </div>
          <div className="col-md-5">
            <div className="col-md-12">
                
              <div className="col-md-6">
                <div className="small-box bg-aqua">
                  <div className="inner">
                    <h3>{this.money(this.state.data.ticket_count)}</h3>
                    <p>تعداد کل پیام ها</p>
                  </div>
                  <div className="icon"><i className="fal fa-life-ring"></i></div>
                  <Link className="small-box-footer" to="/tickets/"><i className="fa fa-list"></i> <span>مشاهده لیست</span></Link>
                </div>
              </div>

              {(this.state.data.current_user.LegalPerson.role_id === 1 || this.state.data.current_user.LegalPerson.role_id === 2||
              this.state.data.current_user.LegalPerson.role_id === 3 || this.state.data.current_user.LegalPerson.role_id === 4  ||
              this.state.data.current_user.LegalPerson.role_id === 5) &&
                <div className="col-md-6">
                  <div className="small-box bg-teal">
                    <div className="inner">
                      <h3>{this.money(this.state.data.mobile_count)}</h3>
                      <p>کاربر موبایلی</p>
                    </div>
                    <div className="icon"><i className="fas fa-mobile-android-alt"></i></div>
                    <Link className="small-box-footer" to="/accounts/mobiles/"><i className="fa fa-list"></i> <span>مشاهده لیست</span></Link>
                  </div>
                </div>
              }

              {(this.state.data.current_user.LegalPerson.role_id === 1 || this.state.data.current_user.LegalPerson.role_id === 2||
              this.state.data.current_user.LegalPerson.role_id === 3 || this.state.data.current_user.LegalPerson.role_id === 4  ||
              this.state.data.current_user.LegalPerson.role_id === 5) &&
                <div className="col-md-6">
                  <div className="small-box bg-purple">
                    <div className="inner">
                      <h3>{this.money(this.state.data.account_count)}</h3>
                      <p>حسابهای مرکز</p>
                    </div>
                    <div className="icon"><i className="fal fa-at"></i></div>
                    <Link className="small-box-footer" to="/accounts/"><i className="fa fa-list"></i> <span>مشاهده لیست</span></Link>
                  </div>
                </div>
              }
              
              {(this.state.data.current_user.LegalPerson.role_id === 1 || this.state.data.current_user.LegalPerson.role_id === 2||
              this.state.data.current_user.LegalPerson.role_id === 3 || this.state.data.current_user.LegalPerson.role_id === 4 ||
              this.state.data.current_user.LegalPerson.role_id === 5 || this.state.data.current_user.LegalPerson.role_id === 6 ||
              this.state.data.current_user.LegalPerson.role_id === 7) &&
                <div className="col-md-6">
                  <div className="small-box bg-yellow">
                    <div className="inner">
                      <h3>{this.money(this.state.data.visit_count)}</h3>
                      <p>تعداد بازدید</p>
                    </div>
                    <div className="icon"><i className="fa fa-eye"></i></div>
                    <Link className="small-box-footer" to="/"><i className="fa fa-list"></i> <span>مشاهده صفحه اختصاصی</span></Link>
                  </div>
                </div>
              }

              {(this.state.data.current_user.LegalPerson.role_id === 1 || this.state.data.current_user.LegalPerson.role_id === 2||
              this.state.data.current_user.LegalPerson.role_id === 3 || this.state.data.current_user.LegalPerson.role_id === 4  ||
              this.state.data.current_user.LegalPerson.role_id === 5) &&
                <div className="col-md-6">
                  <div className="small-box bg-red">
                    <div className="inner">
                      <h3>{this.money(this.state.data.cashe_count)}</h3>
                      <p>رکوردهای مالی</p>
                    </div>
                    <div className="icon"><i className="fal fa-badge-dollar"></i></div>
                    <Link className="small-box-footer" to="/cashes/"><i className="fa fa-list"></i> <span>مشاهده صورتحسابها</span></Link>
                  </div>
                </div>
              }

              <div className="col-md-6">
                <div className="small-box bg-green">
                  <div className="inner">
                    <h3>&nbsp;</h3>
                    <p>&nbsp;</p>
                  </div>
                  <div className="icon"><i className="fa fa-plus"></i></div>
                  <Link className="small-box-footer" to="/tickets/new/"><i className="fa fa-plus"></i> <span>ارسال پیام جدید</span></Link>
                </div>
              </div>

            </div>
            <div className="clearfix"></div>
            {this.renderTicketsBoxs()}
          </div>       
          
        </div>
      )
    }
  }
  export default Dashboard;